<i18n>
{
"en": {
  "UPLOADIMAGE": "Upload Image",
  "SAVEIMAGE": "Save Image",
  "CANCEL": "Cancel",
  "CLOSE": "Close",
  "FILEISTOOLARGERMAXFILEIS": "File is too large, max file is {param}.",
  "TYPEERROR": "File extensions should be {param}."    
},
"ar": {
  "CANCEL": "الغاء",
  "CLOSE": "أغلق",
  "SAVEIMAGE": "احفظ الصورة",
  "UPLOADIMAGE": "تحميل الصور",
  "FILEISTOOLARGERMAXFILEIS": "ملحقات الملفات يجب أن تكون {param}.",
  "TYPEERROR": "ملحقات الملفات يجب أن تكون {param}."      
}
}
</i18n>
<template>
        <div class="avatar-uploader">
          <div class="el-upload el-upload--text">
          <img :src="getAsset(imagePath, undefined, logo)" class="avatar">
        </div>  
        <vue-core-image-upload
            crop-ratio="1:1" 
            v-bind:class="['el-button',' el-button--dark']" 
            v-bind:crop="true" 
            :max-file-size="409600"
            @errorhandle="imageError"
            :text="$t('UPLOADIMAGE')"
            :cropBtn="{'ok':$t('SAVEIMAGE'),'cancel':$t('CANCEL')}"
            :url="URL + 'media/upload'"
            :data="{folder: folder}"
            :headers="{'X-API-KEY': API_KEY}"
            extensions="png,gif,jpeg,jpg"
            inputOfFile="file"
            v-on:imageuploaded="imageUploaded">  
        </vue-core-image-upload>  
        <el-dialog id="WIUpload" size="tiny" @close="resetUpload" :visible.sync="messageBox">
            <div class="el-alert el-alert--error">
                <i class="el-alert__icon el-icon-circle-cross is-big"></i>
                <div class="el-alert__content">
                <span class="el-alert__title is-bold">{{message}}<br/></span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="messageBox = false">{{$t('CLOSE')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  import VueCoreImageUpload from 'vue-core-image-upload'
  export default {
    components: {VueCoreImageUpload},
    name: 'WiUpload',
    componentName: 'WiUpload',
    props: {
      person: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      logo: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        messageBox: false,
        message: null,
        folder: null
      }
    },
    computed: {
      imagePath () {
        return this.person.ImagePath !== undefined ? this.person.ImagePath : this.person.Logo
      }
    },
    mounted () {
      this.folder = this.$route.path.split('/')[2]
      this.switchLanguage()
    },
    methods: {
      imageUploaded (res) {
        if (res.file_name !== undefined) {
          if (this.person.ImagePath !== undefined) this.person.ImagePath = res.file_name
          if (this.person.Logo !== undefined) this.person.Logo = res.file_name
        }
      },
      imageError (res) {
        let string = res.split(' ')
        this.message = this.$t(string[0], {param: string[1]})
        this.messageBox = true
      },
      resetUpload () {
      }
    }
  }
</script>

<style>
.avatar-uploader .el-upload, .avatar-uploader .el-button{display:block}
.avatar-uploader .el-upload img.avatar{width: 100% !important; height: auto !important}
</style>



// WEBPACK FOOTER //
// Upload.vue?1a17de80